import { FC } from 'react';
import { Link } from '@zoopla-eng/zds/link';
import { Box } from '@zoopla-eng/zds/box';
import { fontGroups } from '@zoopla-eng/zds/themes';
import { Button } from '@zoopla-eng/zds/button';
import { LockMedium } from '@zoopla-eng/zds/icons';
import {
    contentStyle,
    styledImgStyle,
    styledLinkContainerStyle,
    styledTextStyle,
    textStyle
} from './ResponseModalContent.styles.css';

export type Props = {
    image: string;
    title: string;
    heading: string;
    text: string;
    buttonAction: () => void;
    buttonText: string;
    linkType: 'url' | 'action';
    linkUrl?: string;
    linkAction?: () => void;
    linkText: string;
    note: string;
};

export const ResponseModalContent: FC<React.PropsWithChildren<Props>> = ({
    image,
    title,
    heading,
    text,
    buttonAction,
    buttonText,
    linkType,
    linkUrl,
    linkText,
    linkAction,
    note
}) => (
    <div className={contentStyle}>
        <img className={styledImgStyle} src={image} alt={title} />
        <Box pb="S500">
            <h4 className={fontGroups.mug}>{heading}</h4>
        </Box>
        <p className={`${styledTextStyle} ${fontGroups.fork}`}>{text}</p>
        <Box pb="S500">
            <Button onClick={buttonAction} category="primary" fw>
                {buttonText}
            </Button>
        </Box>
        <div className={styledLinkContainerStyle}>
            {linkType === 'url' ? (
                <Link href={linkUrl}>{linkText}</Link>
            ) : (
                <Link onClick={linkAction} href="">
                    {linkText}
                </Link>
            )}
        </div>
        <Box pr="S200">
            <p className={`${textStyle} ${fontGroups.spoon}`}>
                <LockMedium accessibilityType="decorative" />
                {note}
            </p>
        </Box>
    </div>
);
